/**
 * A run/node-run status (`tala_run_status`: succeed | failed | cancelled |
 * processing) as a coloured pill — same soft-tone recipe apps/web uses for
 * status chips (bg-<tone>-soft + text-<tone>-soft-foreground), so an admin
 * reading this table sees the same colour language as the product itself.
 */
const TONE_BY_STATUS: Record<string, string> = {
  succeed: 'bg-success-soft text-success-soft-foreground border-success-border',
  failed: 'bg-destructive-soft text-destructive-soft-foreground border-destructive-border',
  cancelled: 'bg-warning-soft text-warning-soft-foreground border-warning-border',
  processing: 'bg-surface-brand-subtle text-fg-secondary border-border',
};

const FALLBACK_TONE = 'bg-surface-muted text-fg-tertiary border-border';

export function StatusPill({ status }: { status: string | null }) {
  const label = status ?? 'unknown';
  const tone = (status && TONE_BY_STATUS[status]) || FALLBACK_TONE;
  return (
    <span
      className={`inline-flex items-center rounded-card border px-2 py-0.5 text-micro font-medium capitalize ${tone}`}
    >
      {label}
    </span>
  );
}
